<template>
    <v-content class="pa-12">
        <!-- Nevigater -->
        <v-layout mb-6>
            <v-flex shrink d-flex justify-start align-center class="nevigater-link" @click="$router.push('/research-approve')">
                <span>โครงการวิจัยที่ผ่านการพิจารณา</span>
            </v-flex>
            <v-flex shrink d-flex justify-start align-center>
                <v-icon color="#3E7662">arrow_right</v-icon>
            </v-flex>
            <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
                <span>ดูข้อมูล</span>
            </v-flex>
        </v-layout>

        <v-layout mt-6 justify-space-around>
            <v-flex shrink mr-6 d-flex justify-start align-center style="font-weight: bold;">
                <span>กรองประเภท</span>
            </v-flex>
            <v-flex d-flex justify-start align-center style="color: #3E7662;">
                <v-radio-group hide-details v-model="filterType" row >

                    <v-layout>
<!--                        <v-flex class="d-flex align-center">-->
<!--                            <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countAll > 0">{{countAll}}</span>-->
<!--                            <v-icon v-if="countAll > 0" small color="#CC3D45">mdi-alert-circle</v-icon>-->
<!--                        </v-flex>-->
                        <v-flex>
                            <v-radio
                                @click="getPaginateResearchByReviewerIDFilter()"
                                    color="#3E7662"
                                    label="1. ทั้งหมด"
                                    value='0'
                            ></v-radio>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex class="d-flex align-center">
                            <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countFullboard > 0">{{countFullboard}}</span>
                            <v-icon v-if="countFullboard > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                        </v-flex>
                        <v-flex>
                            <v-radio
                                @click="getPaginateResearchByReviewerIDFilter()"
                                    color="#3E7662"
                                    label="2. ประเภท Full Board"
                                    value="1"
                            ></v-radio>
                        </v-flex>
                    </v-layout>

                    <v-layout class="ml-12">
                        <v-flex class="d-flex align-center">
                            <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countExpedited > 0">{{countExpedited}}</span>
                            <v-icon v-if="countExpedited > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                        </v-flex>
                        <v-flex>
                            <v-radio
                                @click="getPaginateResearchByReviewerIDFilter()"
                                    color="#3E7662"
                                    label="3. ประเภท Expedited"
                                    value="2"
                            ></v-radio>
                        </v-flex>
                    </v-layout>

                </v-radio-group>
            </v-flex>
        </v-layout>
      <!--การอนุมัติ-->
      <v-layout>
        <v-flex shrink mr-6 d-flex justify-start align-center style="font-weight: bold;">
          <span>การอนุมัติ</span>
        </v-flex>
        <v-flex d-flex justify-start align-center style="color: #3E7662;">
          <v-radio-group hide-details v-model="reviewType" row >
            <v-layout>
              <v-flex>
                <v-radio
                    @click="getPaginateResearchByReviewerIDFilter()"
                    color="#3E7662"
                    label="ยังไม่อนุมัติ"
                    value='0'
                ></v-radio>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-radio
                    @click="getPaginateResearchByReviewerIDFilter()"
                    color="#3E7662"
                    label="อนุมัติแล้ว"
                    value="1"
                ></v-radio>
              </v-flex>
            </v-layout>
          </v-radio-group>
        </v-flex>
      </v-layout>

        <!-- Table -->
        <v-layout mt-4>
            <v-flex>
                <form-table
                        :headers="headers"
                        :items="dataSubcommitteeList"
                        onViewData
                ></form-table>
            </v-flex>
        </v-layout>

        <!-- Pagination -->
        <v-layout mt-12>
            <v-flex>
                <v-pagination
                        color="#3E7662"
                        :length="paginateDataSubcommittee.last_page"
                        :total-visible="9"
                        @input="getPaginateResearchByReviewerIDFilter"
                        v-model="paginateDataSubcommittee.current_page"
                ></v-pagination>
            </v-flex>
        </v-layout>

        <loading
                color="#527281"
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="fullPage"
        ></loading>

    </v-content>
</template>

<script>
    import FormTable from "../../../components/table/FormTable";
    import vSelect from 'vue-select'
    import Swal from 'sweetalert2';
    import Loading from 'vue-loading-overlay';
    import 'vue-select/dist/vue-select.css';
    import { mapState, mapActions } from "vuex";
    export default {
        name: "Meeting",
        components: {
            FormTable,
            vSelect,
            Loading,
        },
        computed: {
            ...mapState({
                user: state => state.Auth.user,
                role: state => state.Auth.role
            })
        },
        data: () => ({
            countAll: 0,
            countFullboard: 0,
            countExpedited: 0,
            filterType: '0',
            reviewType: '0',
            checkRadio1: false,
            checkRadio2: false,
            meetingDialog: false,
            isLoading: false,
            fullPage: true,
            paginateDataSubcommittee: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            headers: [
                {text: 'ลำดับ', value: 'number', align: "center", sortable: false},
                { text: 'ชื่องานวิจัย', value: 'nameResearch', align: "center" },
                { text: 'ประเภท การพิจารณา', value: 'typeApprove', align: "center" },
                { text: 'รอบการประชุม', value: 'joinMeeting', align: "center" },
                { text: 'คนที่', value: 'sequence', align: "center" },
                { text: 'เวอร์ชั่น', value: 'version', align: "center" },
                { text: 'สถานะ', value: 'status', align: "center" },
                { text: 'ดูโครงร่าง', value: 'viewOutline', align: "center" },
                { text: 'ประเมิน', value: 'Evaluation', align: "center", sortable: false},
            ],
          statusList: [
            {'status': 'ประเมินแล้ว'},
            {'status':'ยังไม่ประเมิน'}
          ],
            dataSubcommitteeList: [],

        }),
        created(){
            // Check Permission Access
           if (this.user.id != this.$route.query.id && this.role === 3) {
               this.$router.push('/research-approve');
           }
            this.getFullBoard(1);
            this.getExpedited(1);
            this.getPaginateResearchByReviewerIDFilter(1);
        },
        methods: {
            getPaginateResearchByReviewerIDFilter(page) {
                let data = {
                    page: page,
                    id: this.$route.query.id,
                    considerType: this.filterType,
                    reviewType: this.reviewType
                };
                this.isLoading = true;
                this.$store.dispatch('Research/getPaginateResearchByReviewerIDFilter',data).then(res => {
                    this.isLoading = true;
                    this.dataSubcommitteeList = [];
                    let i = 1;
                    res.data.forEach(data => {
                      let mainResearcherThName = data.mainResearcherData.thName.split(" ").filter(function (el) {
                        return el !== "";
                      });
                        this.dataSubcommitteeList.push({
                            number: i,
                            id: data.researchID,
                            mainResearcherThName: mainResearcherThName,
                            researchID: data.researchID,
                            nameResearch: data.research.thResearchName,
                            researchCode: data.research.researchCode,
                            typeApprove: data.research.research_type,
                            joinMeeting: data.meeting === null ? '-' : 'รอบที่ '+data.meeting.meetingNumber +' '+ data.meeting.Date,
                            sequence: data.sequence,
                            version: data.research ? data.research.version : '',
                            isPast: !this.checkRadio2 ? data.meeting ? data.meeting.isPast : '' : '',
                            status: data.isRead === 0 ? 'ยังไม่ได้อ่าน' : 'อ่านแล้ว',
                            data: data,
                            onView: 1,
                            user_id: this.$route.query.id,
                            reviewerName: data.user.thName,
                            Evaluation: data.form,
                        });
                        console.log('finish',this.dataSubcommitteeList);
                        i++;
                    });
                    this.paginateDataSubcommittee.current_page = res.current_page;
                    this.paginateDataSubcommittee.from = res.from;
                    this.paginateDataSubcommittee.last_page = res.last_page;
                    this.paginateDataSubcommittee.per_page = res.per_page;
                    this.paginateDataSubcommittee.total = res.total;
                    this.paginateDataSubcommittee.to = res.to;
                    this.isLoading = false;
                }).catch(e => {
                    this.isLoading = false;
                })
            },
            getFullBoard(page) {
                let data = {
                    page: page,
                    id: this.$route.query.id,
                    considerType: 1,
                };
                this.isLoading = true;
                this.$store.dispatch('Research/getPaginateResearchByReviewerIDFilter',data).then(res => {
                    this.isLoading = false;
                    let i = 0;
                    res.data.forEach(data => {
                        if (data.isRead === 0) {
                            i++;
                        }
                    })
                    this.countFullboard = i;
                }).catch(e => {
                    this.isLoading = false;
                })
            },
            getExpedited(page) {
                let data = {
                    page: page,
                    id: this.$route.query.id,
                    considerType: 2,
                };
                this.isLoading = true;
                this.$store.dispatch('Research/getPaginateResearchByReviewerIDFilter',data).then(res => {
                    this.isLoading = false;
                    let i = 0;
                    res.data.forEach(data => {
                        if (data.isRead === 0) {
                            i++;
                        }
                    })
                    this.countExpedited = i;
                }).catch(e => {
                    this.isLoading = false;
                })
            }
        }
    }
</script>

<style lang="scss">
    // V-select
    .style-chooser .vs__search::placeholder,
    .style-chooser .vs__dropdown-toggle,
    .style-chooser .vs__selected
        /*.style-chooser .vs__dropdown-menu:hover*/
    {
        background: #3E7662;
        border: solid 2px #3E7662;
        color: #fff;
        /*text-transform: lowercase;*/
        /*font-variant: small-caps;*/
    }

    .style-chooser .vs__clear,
    .style-chooser .vs__open-indicator {
        fill: #fff;
    }

</style>
